export async function checkAppVersion() {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    const response = await fetch('/version.json', { cache: 'no-store' });
    if (!response.ok) return;

    const { version } = await response.json();
    const localVersion = Number(import.meta.env.VITE_APP_VERSION || 0);

    if (version > localVersion) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.update()));
      window.location.reload();
    }
  } catch (error) {
    console.warn('App version check failed:', error);
  }
}
